var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
    _c("div", { staticClass: "control" }, [
      _c("div", { staticClass: "pretty p-switch p-fill" }, [
        _c(
          "div",
          {
            staticClass: "tags has-addons",
            staticStyle: { "margin-left": "auto" },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newValue,
                  expression: "newValue",
                },
              ],
              attrs: {
                type: "checkbox",
                disabled: _vm.disabledCheckbox,
                "true-value": _vm.trueValue,
                "false-value": _vm.falseValue,
              },
              domProps: {
                checked: !!_vm.newValue,
                checked: Array.isArray(_vm.newValue)
                  ? _vm._i(_vm.newValue, null) > -1
                  : _vm._q(_vm.newValue, _vm.trueValue),
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.newValue,
                    $$el = $event.target,
                    $$c = $$el.checked ? _vm.trueValue : _vm.falseValue
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.newValue = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.newValue = $$c
                  }
                },
              },
            }),
            _c("div", { staticClass: "state p-primary mr-2" }, [
              _c("label", [_vm._v(_vm._s(_vm.newValue ? "Yes" : "No") + " ")]),
            ]),
            _vm.date
              ? _c("span", { staticClass: "tag is-dark" }, [
                  _vm._v("Last saved"),
                ])
              : _vm._e(),
            _vm.date
              ? _c("span", { staticClass: "tag is-success" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$filters.formatDateTimeLocale(
                        _vm.date,
                        _vm.$userInfo.locale
                      )
                    )
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }